(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Mobile nav controller — small enough to inline here rather than bloat global.js */
  (function () {
    const root = document.documentElement;
    const drawer = document.querySelector('[data-mobile-nav]');
    if (!drawer) return;
    const panel = drawer.querySelector('.mobile-nav__panel') || drawer;
    const triggers = document.querySelectorAll('[data-mobile-nav-trigger]');
    const closeEls = drawer.querySelectorAll(
      '[data-mobile-nav-close], [data-mobile-nav-overlay]'
    );
    const focusableSelector =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';
    let lastFocused = null;

    const isOpen = () => drawer.getAttribute('aria-hidden') === 'false';

    /* A closed drawer is inert so its off-screen links stay out of the tab order
       and the accessibility tree (synchronous — no CSS visibility timing issues). */
    if (!isOpen()) drawer.inert = true;

    function open() {
      lastFocused = document.activeElement;
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      root.classList.add('is-scroll-locked');
      triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
      /* Move focus into the drawer so keyboard/screen-reader users start inside. */
      const closeBtn = drawer.querySelector('[data-mobile-nav-close]');
      (closeBtn || panel.querySelector(focusableSelector))?.focus();
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-scroll-locked');
      triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
      /* Restore focus to the control that opened the drawer. */
      lastFocused?.focus?.();
      drawer.inert = true;
    }
    /* Keep Tab focus cycling within the open drawer. */
    function trapFocus(e) {
      const focusables = Array.from(
        panel.querySelectorAll(focusableSelector)
      ).filter((el) => el.offsetParent !== null);
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    triggers.forEach((t) => t.addEventListener('click', open));
    closeEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'Tab') trapFocus(e);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
